interface IThumbFilePlaceholderProps {
	fileExtension: string;
}

export default function ThumbFilePlaceholder({ fileExtension }: IThumbFilePlaceholderProps) {
	return (
		<svg className="h-full w-full" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z" fill="#244FEC" />
			<path opacity="0.3" d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z" fill="white" />
			<text className="uppercase" x="50%" y="32" textAnchor="middle" fontSize={"10px"} fontWeight={700} fontFamily="" fill="#ffffff">{fileExtension}</text>
		</svg>
	)
}